interface QuestFormActionsProps {
    onCancel: () => void;
    onSaveAndContinue?: () => void;
    loading: boolean;
    isEditMode: boolean;
}

export const QuestFormActions = ({ onCancel, onSaveAndContinue, loading, isEditMode }: QuestFormActionsProps) => {
    return (
        <div className="flex flex-col sm:flex-row gap-3 pt-6 border-t border-gray-200">
            <button
                type="button"
                onClick={onCancel}
                className="flex-1 px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50"
                disabled={loading}
            >
                Cancel
            </button>
            {onSaveAndContinue && (
                <button
                    type="button"
                    onClick={onSaveAndContinue}
                    className="flex-1 px-4 py-2 text-sm font-medium text-white bg-green-600 border border-transparent rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 disabled:opacity-50"
                    disabled={loading}
                >
                    {loading ? 'Saving...' : 'Save & Continue'}
                </button>
            )}
            <button
                type="submit"
                className="flex-1 px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50"
                disabled={loading}
            >
                {loading ? 'Saving...' : (isEditMode ? 'Update Quest Template' : 'Create Quest Template')}
            </button>
        </div>
    );
};

